import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, patch, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetBannerParameter extends ApiParameter {
    parameter: string;
}

export interface BannerModel extends BaseModel {
    id: string;
    pageName: string;
    startDate: string;
    endDate: string;
    persona: string;
    rank: number;
    description: string;
    richContent: string;
    cssClass: string;
    backgroundImage: string;
    imageURL: string;
    callToAction: string;
    imageAlternativeText: string;
    bodyAlignment: string;
    imageAlignment: string;
    centerBoxbackground: string;
    pageRelativeURL: string;
    customerNumber: string;
    dc: string;
    siteName: string;
    message: string;
    bannerAccessLevel: string;
    headerLineOne: string;
    headerLineTwo: string;
    copyTextOne: string;
    copyTextTwo: string;
    copyTextThree: string;
    smallCopyTextOne: string;
    smallCopyTextTwo: string;
    bannerLinkUrl: string;
    logoImageUrl: string;
    bannerButtonText: string;
    promoLayout: string;
    status: string;
    mobileBannerClass: string;
    neverExpire: boolean;
    isNewTab: boolean;
    sortOption: string;
    contentType: string;
    publish: boolean;
    isMiniBanner: boolean;
    isPDPBanner: boolean;
    isRewardEnrolledUser: boolean;
    isRewardInvitedUser: boolean;
}

const getBannerUrl = "/api/v2/getbannerbyID";
export async function getBanner(parameter: GetBannerParameter) {
    const response = await get<BannerModel>(`${getBannerUrl}`, parameter as any);
    return response;
}

const addBannerUrl = "/api/v2/addbanner";
export async function addBanner(parameter: BannerModel): Promise<ServiceResult<BannerModel>> {
    try {
        const bannerModel = await post<BannerModel>(`${addBannerUrl}`, parameter as any);
        return {
            result: bannerModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && (error.status === 400 || error.status === 401)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

const validateMarketingTileUrl = "/api/v2/validateMarketingTile";
export async function validateMarketingTile(parameter: BannerModel) {
    const response = await patch<any>(`${validateMarketingTileUrl}`, parameter as any);
    return response;
}
